import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Hot Spot",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-hot-spot",
    args: {
        bullet: false,
        hotSpotId: "1",
        icon: "",
        left: 0,
        number: "1",
        top: 0,
    },
    argTypes: {
        bullet: { control: "boolean" },
        hotSpotId: { control: "text" },
        icon: { control: "text" },
        left: { control: "number" },
        number: { control: "text" },
        top: { control: "number" },
    },
};

const Template = () => {
    const hotSpots = [
        {
            id: "1",
            number: "1",
            title: "Test1",
            icon: "",
            bullet: false,
            info: html`<div>
                <h2>Foo1</h2>
                <p>Lorem Ipsum</p>
            </div>`,
            left: 20,
            top: 10,
        },
        {
            id: "2",
            number: "2",
            title: "Foo2 has a long title",
            icon: "globe",
            bullet: false,
            info: html`<div>
                <h2>Foo2</h2>
                <p>2Lorem 2Ipsum</p>
            </div>`,
            left: 44,
            top: 50,
        },
        {
            id: "3",
            number: "",
            title: "LongFooFooFoo3",
            icon: "",
            bullet: true,
            info: html`<div>
                <h2>Foo3</h2>
                <p>3Lorem 3Ipsum</p>
            </div>`,
            left: 64,
            top: 80,
        },
        {
            id: "4",
            number: "",
            title: "",
            icon: "",
            bullet: true,
            info: html`<div>
                <h2>Foo4</h2>
                <p>4Lorem 4Ipsum</p>
            </div>`,
            left: 22,
            top: 77,
        },
    ];
    return html` <ux-iws-hot-spot-container>
        <div slot="image">
            <img src="./mock-assets/images/trumpf-outdoor.jpg" />
        </div>
        <div slot="hot-spots">
            ${hotSpots.map(
                (spot) =>
                    html`<ux-iws-hot-spot
                        hot-spot-id="${spot.id}"
                        number="${spot.number}"
                        icon="${spot.icon}"
                        left="${spot.left}"
                        top="${spot.top}"
                        bullet="${spot.bullet}"
                    >
                        ${spot.title !== "" ? html`${spot.title}` : ""}
                    </ux-iws-hot-spot>`
            )}
        </div>
        <div slot="info-box">
            ${hotSpots.map(
                (spot) =>
                    html`<ux-iws-hot-spot-info hot-spot-id="${spot.id}"
                        >${spot.info}</ux-iws-hot-spot-info
                    >`
            )}
        </div>
    </ux-iws-hot-spot-container>`;
};

export const Default = Template.bind({});
